<template>
  <div
    class="product-top-bar personalization__banner"
    :class="`personalization__banner--type_${getPersonalPreferenceRank()}`"
    v-if="content"
    v-html="content"
  />
</template>

<script lang="ts">
  import {Vue, Options} from 'vue-property-decorator';
  import productStore from '../../../bps/stores/product/ProductStore';
  import {usePlaceholder} from '../../../bps/utilities/vueMixins/placeholderMixin/placeholder';

  @Options({
    name: 'product-top-bar',
  })
  export default class ProductTopBar extends Vue {
    productStore = productStore;

    mounted() {
      usePlaceholder('product-top-bar');
    }

    get content(): string {
      if (this.productStore.customerWinePreferenceKey) {
        return `
        <div class="product-box__personalization-banner-icon | personalization__banner-icon personalization__banner-icon--lg"></div>
        <div class="product-box__personalization-banner-content | personalization__banner-content">
          ${this.$t(this.productStore.customerWinePreferenceKey)}
        </div>
        `;
      }

      return '';
    }

    getPersonalPreferenceRank() {
      return this.productStore.customerWinePreferenceKey.split('.').pop();
    }
  }
</script>
